/*
 *
 * File JS componente Accordion
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./accordion.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const accordion = () => {};

$(".desy-accordion__toggle").on("click", function () {
  $(this).children(".icon-close").toggleClass("open");
});
const accordionBtns = document.querySelectorAll(".desy-accordion__toggle");
accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {


    // Close all other accordion items
    accordionBtns.forEach((item) => {
      if (item !== this) {
        item.classList.remove("is-open");
        item.children[1].classList.remove("open"); // Close icon
        let content = item.nextElementSibling;
        content.style.maxHeight = null;
      }
    });




    this.classList.toggle("is-open");
    let content = this.nextElementSibling;
    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});

export default accordion;

//--------------------------------------------------------------------//
